import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  ArcElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Card, CardBody, CardHeader } from "../../../components/card/card";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ dataSource }) {
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        position: "bottom",
      },
    },
  };
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true)
  const [dataTable, setDataTable] = useState([])
  const colors = [themeColor, "#f0ad4e", "#5cb85c", "#d9534f", "#5bc0de"];

  // labels will be the date of data source if it exist only one date in the label
  useEffect(() => {
    if (dataSource && dataSource.length) {
      const labels = [];

      const datasets = [];
      const datas = [];
      dataSource.map((item, index) => {
        labels.push(item.category);
        datas.push(item.count);
        setDataTable((prev) => [...prev, { category: item.category, count: item.count }])
      });
      datasets.push({
        label: "# of Work Orders",
        data: datas,
        backgroundColor: colors,
        borderColor: colors,
      });

      const data = {
        labels,
        datasets: datasets,
      };
      setData(data);
    } else {
      setData(null);
    }
    setLoading(false)
  }, [dataSource]);

  return (
    <div className="row">
      <div className="col-12">
        <Card className="border-theme mb-3">
          <CardBody>
            <div className="d-flex align-items-center mb-2"></div>
            <div>
              <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50 text-center">
                By Category
              </div>
              <div className="chart mb-2" style={{ height: "auto" }}>
                {!loading ? (
                  <div
                    style={{
                      position: "relative",
                      height: "auto",
                      width: "100%",
                    }}
                  >
                    {/* {data ? <Doughnut data={data} options={options} /> : null} */}
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Category</th>
                          <th>Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataSource.map((item, index) => (
                          <tr key={index}>
                            <td>{item.category}</td>
                            <td>{item.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div>
                    <div className="spinner-grow text-primary"></div>
                  </div>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
      {/* <div className="col-4">
        {dataSource.map((item, index) => (
          <Card className="bg-theme border-theme bg-opacity-25 mb-3">
            <CardHeader className="border-theme fw-bold small text-white">
              <div style={{ textAlign: "center" }}>
                <h3>{item.count}</h3>
              </div>
            </CardHeader>
            <CardBody>
              <div style={{ textAlign: "center" }}>
                <div>{item.category}</div>
              </div>
            </CardBody>
          </Card>
        ))}
      </div> */}
    </div>
  );
}
export default App;
